var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluearrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.75591 1C8.40935 1 8.12499 1.12424 7.89394 1.35496L1.07819 8.00166C0.776054 8.30338 0.624987 8.61398 0.624987 8.99556C0.624987 9.37715 0.767167 9.69662 1.07819 9.98946L7.89394 16.645C8.13387 16.8758 8.41823 17 8.75591 17C9.44015 17 9.99999 16.4498 9.99999 15.7665C9.99999 15.4293 10 15.7665 9.99993 15L10 9L9.99997 3C9.99997 3 9.99999 2.57071 9.99999 2.2335C9.99999 1.55019 9.44015 1 8.75591 1Z",
    fill: "#329DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluearrowleft);
export default __webpack_public_path__ + "static/media/bluearrowleft.7d38ab9846b1567e6e7ff82246e2102f.svg";
export { ForwardRef as ReactComponent };